/** One physical unit of stock as the planner sidebar lists it. */
export interface PlannerGarageAsset {
  id: string;
  serial_number: string | null;
  hardware_variant: string;
  hardware_variant_sku?: string;
  sentinels_product: string | null;
  lifecycle_state: string;
  stock_location: string | null;
  /** Resolved stock location name, or the free-text warehouse note. */
  location_name: string;
  warehouse_loc: string;
  qr_code: string | null;
}

export interface PlannerGarage {
  assets: PlannerGarageAsset[];
  /** Available units in total; `assets` holds at most the first 200. */
  total: number;
  /** True when more units exist than are listed. */
  truncated: boolean;
}

/**
 * `GET /cases/garage/available/` answers `{ results, count }`; the axios
 * pagination interceptor may hoist `results` to `data` and `count` to
 * `meta.total`. Accept both shapes and never trust a count below the list.
 */
export function normalizePlannerGarage(
  envelope:
    | {
        data?:
          | PlannerGarageAsset[]
          | { results?: PlannerGarageAsset[]; count?: number }
          | null;
        meta?: Record<string, unknown> | null;
      }
    | undefined,
): PlannerGarage {
  const payload = envelope?.data;
  const assets = Array.isArray(payload) ? payload : (payload?.results ?? []);
  const metaTotal = envelope?.meta?.total;
  const total = Math.max(
    typeof metaTotal === "number"
      ? metaTotal
      : Array.isArray(payload)
        ? assets.length
        : (payload?.count ?? assets.length),
    assets.length,
  );
  return { assets, total, truncated: assets.length < total };
}
